module.exports = __webpack_public_path__ + "img/图2.533ce24e.png";